var lastScroll = 0;
const handleScrollResize = () => {
  let scrollCount = window.pageYOffset;
  let header = document.querySelector('.shopify-section-header');
  header.classList.add('solid_header');
  if (scrollCount === 0) {
    header.classList.remove('solid_header');
  }
  if (document.querySelector('body.template-collection') || document.querySelector('body.template-collection-gold-exclusive') || document.querySelector('body.template-search')) {
    let announce = document.querySelector('.shopify-section-announcement-bar');
    let headerEl = document.querySelector('body:not(.open-menu) .shopify-section-header');
    if (announce) {
      if (scrollCount >= (headerEl.offsetHeight + announce.offsetHeight)) {
        let sectionHeaderHeight = document.querySelector('body:not(.open-menu) .section-header').offsetHeight;
        document.body.style.setProperty("--header-height", `${sectionHeaderHeight}px`);
        headerEl.style.height = sectionHeaderHeight + 'px';
        headerEl.classList.add('is-fixed');
        document.querySelector('.section-header').style.top = '-' + sectionHeaderHeight + 'px';
      } else {
        headerEl.classList.remove('is-fixed');
      }
    } else {
      if (scrollCount >= headerEl.offsetHeight) {
        document.body.style.setProperty("--header-height", `${headerEl.offsetHeight}px`);
        headerEl.style.height = headerEl.offsetHeight + 'px';
        headerEl.classList.add('is-fixed');
        document.querySelector('.section-header').style.top = '-' + headerEl.offsetHeight + 'px';
      } else {
        headerEl.classList.remove('is-fixed');
      }
    }
    let filter = document.querySelector('.collection-filter');
    if (filter && scrollCount >= filter.scrollHeight) {
      document.body.classList.add('sticky-filter');
      filter.style.height = filter.offsetHeight + 'px';
    } else {
      document.body.classList.remove('sticky-filter');
    }
  }
  if (scrollCount > header.offsetTop) {
    header.classList.add('sticky_header');
  }
  if (scrollCount < document.querySelector('.shopify-section-announcement-bar').clientHeight &&
      document.body.classList.contains('scroll-up')) {
    header.classList.remove('sticky_header');
  }
  setTimeout(() => {
    if (scrollCount > lastScroll) {
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    } else if (scrollCount < lastScroll) {
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 0);
};
window.addEventListener('scroll', handleScrollResize);
window.addEventListener('resize', handleScrollResize);
document.addEventListener('DOMContentLoaded', handleScrollResize);
document.addEventListener("DOMContentLoaded", (event) => {
  let scrollCount = window.pageYOffset;
  let header = document.querySelector('.shopify-section-header');
  header.classList.add('solid_header');
  if(scrollCount == 0){
    header.classList.remove('solid_header');
  }
  if(scrollCount > header.offsetTop){
    header.classList.add('sticky_header');
  }
});

let goldList = document.querySelector('.mega-list[data-val="goldbergh-exclusive"]');
let goldLink = goldList?.querySelector('a');
if (goldList && goldLink){
  goldLink.addEventListener('click', function (e) {
    e.preventDefault();
    goldList.classList.toggle('active-gold');
  });
  goldList.addEventListener('mouseenter', function () {
    goldList.classList.add('active-gold');
  });
  goldList.addEventListener('mouseleave', function () {
    goldList.classList.remove('active-gold');
  });
}
// if(document.querySelector('.mega-list[data-val="goldbergh-exclusive"] a')) document.querySelector('.mega-list[data-val="goldbergh-exclusive"] a').addEventListener('click',function(e){
//   e.preventDefault();
//   document.querySelector('.mega-list[data-val="goldbergh-exclusive"]').classList.toggle('active-gold');
// })
if(document.querySelector('.gold-back-link a')) document.querySelector('.gold-back-link a').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('.mega-list[data-val="goldbergh-exclusive"]').classList.remove('active-gold');
})
if(document.querySelector('.lang-back, .md-modal-closeButton')) document.querySelector('.lang-back, .md-modal-closeButton').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('body').classList.remove('open-currency');
});
if(document.querySelectorAll('.searchlist')) document.querySelectorAll('.searchlist').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-wishlist');
    setTimeout(() => {
      document.querySelector(".searchbox #Search").focus();
    },400);
    var Swipes = new Swiper('.popular_items_slider', {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 12,
      a11y: true,
      resizeObserver: false,
      navigation: {
        nextEl: ".popular_items .swiper-button-next",
        prevEl: ".popular_items .swiper-button-prev",
      },
    });
  });
});
if(document.querySelectorAll('.close_search')) document.querySelectorAll('.close_search').forEach(function(searchClose){
  searchClose.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-search');
  });
});
document.addEventListener('DOMContentLoaded', function(){
  if(document.querySelectorAll('.mega-coll-inr')) document.querySelectorAll('.mega-coll-inr').forEach((el, index) => {
    if(el.closest('.mega-coll')){
      new Swiper(el, {
        loop: false,
        slidesPerView: "auto",
        slidesPerGroup: 2,
        a11y: true,
        resizeObserver: false,
        navigation: {
          nextEl: el.closest('.mega-coll').querySelector(".swiper-button-next"),
          prevEl: el.closest('.mega-coll').querySelector(".swiper-button-prev"),
        },
      });
    }else{
      new Swiper(el, {
        loop: false,
        slidesPerView: "auto",
        slidesPerGroup: 2,
        a11y: true,
        resizeObserver: false,
      });
    }
    
  });
});
if(document.querySelectorAll('.mobile-nav > li> .nav-wrap,.navmobile-dropdown li.has-img .nav-wrap')) document.querySelectorAll('.mobile-nav > li> .nav-wrap,.navmobile-dropdown li.has-img .nav-wrap').forEach(function(navArrow){
  navArrow.addEventListener('click',function(e){
    e.preventDefault();
    navArrow.closest('li').querySelector('.navmobile-dropdown').classList.add('active');
    navArrow.closest('.snippet-menu-drawer').classList.add('hidescroll');
  });
});
if(document.querySelectorAll('.back-menu')) document.querySelectorAll('.back-menu').forEach(function(backMenu){
  backMenu.addEventListener('click',function(e){
    e.preventDefault();
    if(document.body.classList.contains('full-currency')){
      setTimeout(() => {
        document.body.classList.remove('full-currency');
      }, 1000);
    }
    if(backMenu.closest('.snippet-menu-drawer')){
      backMenu.closest('.snippet-menu-drawer').classList.remove('hidescroll');
      backMenu.closest('.navmobile-dropdown').classList.remove('active');
    }
  });
});
if(document.querySelectorAll('.navmobile-dropdown li .nav-wrap')) document.querySelectorAll('.navmobile-dropdown li .nav-wrap').forEach(navmobile => {
  let mb_nav_cont = navmobile.closest('li').querySelector('.grand-nav-mb-dropdown');
  if(mb_nav_cont){
    mb_nav_cont.style.maxHeight = '0';
    navmobile.addEventListener('click', (e) => {
      e.preventDefault();
      if(window.innerWidth < 992){
        let isOpen = navmobile.closest('li').classList.contains('active');
        document.querySelectorAll('.navmobile-dropdown li').forEach(otherItem => {
          if(otherItem !== navmobile){
            let otherContent = otherItem.querySelector('.grand-nav-mb-dropdown');
            otherItem.classList.remove('active');
            if(otherContent) otherContent.style.maxHeight = '0';
          }
        });
        if(!isOpen){
          navmobile.closest('li').classList.add('active');
          mb_nav_cont.style.maxHeight = `${mb_nav_cont.querySelector('ul').offsetHeight}px`;
        }else{
          navmobile.closest('li').classList.remove('active');
          mb_nav_cont.style.maxHeight = '0';
        }
      }
    });
  }
});